import { useMemo } from "react";
import { useTranslate } from "react-admin";

import type { CrmObject } from "../generated/graphql";

export type CrmLabels = {
  object: (object: CrmObject, many?: boolean) => string;
  field: (object: CrmObject, key: string) => string;
  listView: (object: CrmObject, key: string) => string;
  section: (key: string) => string;
  related: (key: string) => string;
};

// Labels of the layouts the backend sends; an unknown key shows as itself.
export const useCrmLabels = (): CrmLabels => {
  const translate = useTranslate();
  return useMemo(
    () => ({
      object: (object, many = false) => translate(`crm.objects.${object}.${many ? "many" : "one"}`, { _: object }),
      field: (object, key) => translate(`crm.fields.${object}.${key}`, { _: key }),
      listView: (object, key) => translate(`crm.listViews.${object}.${key}`, { _: key }),
      section: key => translate(`crm.sections.${key}`, { _: key }),
      related: key => translate(`crm.related.${key}`, { _: key }),
    }),
    [translate]
  );
};
